export default __webpack_public_path__ + "static/media/Blumenbild.e4760939.png";